"use client"

import React, {useState} from 'react';
import {AdvancedMarker, InfoWindow, Pin, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";

type MarkerProps = {
  title: string,
  latitude: number,
  longitude: number,
  background: string,
  border: string
  glyph: string
  content?: string,
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

export default function MapMarker(props: MarkerProps) {
  const {title, content, background, border, glyph, latitude, longitude, children, icon} = props
  const [show, setShow] = useState<boolean>(false)

  const [markerRef, marker] = useAdvancedMarkerRef();
  const position = {lng: Number(longitude), lat: Number(latitude)}
  return <AdvancedMarker
    ref={markerRef}
    onClick={(e) => {
      e.stopPropagation()
      setShow(true)
    }} position={position}>
    {show && <InfoWindow onClose={() => {
      setShow(false)
    }} anchor={marker}>
      <h3>{title}</h3>
      {content && <div dangerouslySetInnerHTML={{__html: content}}/>}
      {children}
    </InfoWindow>}
    {!icon &&
        <Pin
            background={background}
            borderColor={border}
            glyphColor={glyph}
        />
    }
    {icon}
  </AdvancedMarker>
}
